Backbone.Model.prototype.toJSON = function () {
    var json = _.clone(this.attributes);
    for (var attr in json) {
        if ((json[attr] instanceof Backbone.Model) || (json[attr] instanceof Backbone.Collection)) {
            json[attr] = json[attr].toJSON();
        }
    }
    return json;
};


function unpackList(contents, itemCreateFn) {
    let listInput = [];
    if (contents != null) {
        arrayForEach(contents, function (item) {
            listInput.push(itemCreateFn(item));
        });
    }

    return listInput;
}

function bindCheckboxToModel(checkbox, model, attribute) {
    checkbox.setChecked(model.get(attribute) === true);
    checkbox.change(function () {
        model.set(attribute, checkbox.isChecked());
        plannerApplication.userDataUpdated();
    });
}

function bindRadioToModel(radio, model, attribute, onValue) {
    radio.setChecked(false);
    if(model.get(attribute) === true) {
        radio.filter('[value="'+onValue+'"]').setChecked(true);
    }
    radio.change(function () {
        let checked = radio.filter(':checked');
        let val = checked.attr('value');
        let selected = val === onValue;
        model.set(attribute, selected);
        plannerApplication.userDataUpdated();
    });
}

function bindSliderToModel(slider, model, attribute, postUpdateFn) {
    slider.val(model.get(attribute));
    postUpdateFn(slider);
    slider.change(function () {
        model.set(attribute, parseInt(slider.val()));
        postUpdateFn(slider);
        plannerApplication.userDataUpdated();
    });
}

function populateNDaysAWeek(n) {
    let days = []
    for (let i = 1; i <= n; i++) {
        days.push(i);
    }
    return days;
}
